import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=23c1f912&scoped=true"
import script from "./Deliver.vue?vue&type=script&lang=js"
export * from "./Deliver.vue?vue&type=script&lang=js"
import style0 from "./Deliver.vue?vue&type=style&index=0&id=23c1f912&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1f912",
  null
  
)

export default component.exports